import { useTypedQuery } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDmsUsersQuery = (dealerLocationId: number) =>
  useTypedQuery({
    queryKey: UsersDashboardQueryKeys.dmsUsers,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { dealer_location_id: dealerLocationId }, baseUrl)).data.dms_users,
    enabled: !!dealerLocationId
  });
